import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import { EQueryKeys } from 'constants/enums';
import useAxios from 'hooks/useAxios';
import { getPublisherIdByPortalId } from 'utils/portalUtils';

import {
  EApiRoutes,
  fetchConfig,
  getApiRouteOrMock
} from './api.utils';
import { useUserDetails } from './useUserDetails';

export default function useBlockedPlayers() {
  const axios = useAxios();
  const { publisherId, portalId } = useParams();
  const { userDetails } = useUserDetails();

  const effectivePublisherId = publisherId || (portalId ? getPublisherIdByPortalId(portalId, userDetails) : undefined);
  const publisherHeader = effectivePublisherId ? { 'x-publishers': effectivePublisherId } : undefined;

  const getBlockedPlayers = useQuery({
    ...fetchConfig.list,
    queryKey: [EQueryKeys.BLOCKED_PLAYERS, effectivePublisherId],
    queryFn: async () => {
      return await axios.get(
        getApiRouteOrMock(EApiRoutes.BLOCKED_PLAYERS),
        {},
        publisherHeader
      );
    },
    enabled: !!effectivePublisherId
  });
  return {
    getBlockedPlayers
  };
}
